import LoadingIconComponent from 'components/Orders/iconComponent/LoadingIconComponent';
import { useCalculateFromSaleReport } from 'hooks/useCalculate';
import { formatReportAmount, getTotalGananciaTextClassName, getTotalGananciaUyu, isCanceledOrderStatus, UYU_TO_USD_RATE } from 'utils/reportSalesUtils';

const PriceLoading = () => (
  <span className='inline-flex items-center text-gray-400'>
    <LoadingIconComponent className='text-gray-400 mr-0 h-4 w-4' />
  </span>
);

const formatUsdWithUyu = (usd) =>
  `${Math.floor(usd)} (${formatReportAmount(Math.floor(usd) * UYU_TO_USD_RATE)})`;

const useSaleReportPriceBreakdown = (amazonPrice, amazonWeight) => {
  const query = useCalculateFromSaleReport(amazonPrice, amazonWeight);
  const hasInputs = amazonPrice != null && amazonWeight != null;

  return { ...query, hasInputs };
};

export const MailboxPriceCell = ({ amazonPrice, amazonWeight }) => {
  const { data, isLoading, isError, hasInputs } = useSaleReportPriceBreakdown(
    amazonPrice,
    amazonWeight
  );

  if (!hasInputs) return '-';
  if (isLoading) return <PriceLoading />;
  if (isError || data?.shipping == null) return '-';

  return formatUsdWithUyu(data.shipping);
};

export const AmazonTotalPriceCell = ({ amazonPrice, amazonWeight }) => {
  const { data, isLoading, isError, hasInputs } = useSaleReportPriceBreakdown(
    amazonPrice,
    amazonWeight
  );

  if (!hasInputs) return '-';
  if (isLoading) return <PriceLoading />;
  if (isError || data?.shipping == null) return '-';

  const totalUsd = Math.floor(Number(amazonPrice)) + Math.floor(data.shipping);

  return formatUsdWithUyu(totalUsd);
};

export const TotalGananciaCell = ({ amazonPrice, amazonWeight, totalNeto, statusOrder }) => {
  const isCanceled = isCanceledOrderStatus(statusOrder);
  const { data, isLoading, isError, hasInputs } = useSaleReportPriceBreakdown(
    amazonPrice,
    amazonWeight
  );

  if (!hasInputs) return '-';
  if (!isCanceled && totalNeto == null) return '-';
  if (isLoading) return <PriceLoading />;
  if (isError || data?.shipping == null) return '-';

  const ganancia = getTotalGananciaUyu({
    totalNeto,
    amazonPrice,
    shipping: data.shipping,
    statusOrder,
  });

  if (ganancia == null) return '-';

  return (
    <span className={getTotalGananciaTextClassName(ganancia, statusOrder)}>
      {formatReportAmount(ganancia)}
    </span>
  );
};
